import { render, staticRenderFns } from "./ListaDePagamentosEletronicos.vue?vue&type=template&id=680208ec&scoped=true"
import script from "./ListaDePagamentosEletronicos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDePagamentosEletronicos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListaDePagamentosEletronicos.vue?vue&type=style&index=0&id=680208ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680208ec",
  null
  
)

export default component.exports